import { Product, PagerItem } from '@/types';

export type State = {
    isLoading: boolean;
    items: Product[] | [];
    pager: PagerItem[];
    nextPageUrl: string | null;
}

export const state: State = {
    isLoading: false,
    items: [],
    pager: [],
    nextPageUrl: null
};
